import OIDCNorway from './bankid_norway';

export default {

    /** @namespace oidc.norway */
    norway: OIDCNorway
    
}